import { Sidebar, Menu, MenuItem, useProSidebar, SubMenu } from "react-pro-sidebar"; //useProSidebar is a hook that lets us access and manage sidebar state
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HealingIcon from '@mui/icons-material/Healing';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import LogoutIcon from '@mui/icons-material/Logout';
import useAuth from "../../hooks/useAuth";
function MySideBar(props) {
  //importing the rtl prop in the useProSidebar hook along with the collapseSidebar prop to enable us reverse the sidebar direction.
  const { collapseSidebar, toggleSidebar, collapsed, toggled, broken, rtl } = useProSidebar();
  const navigate = useNavigate();
   const {logout} = useAuth()
  const handlenavigate = to =>{
      navigate(to);
      toggleSidebar()
  }
  return (
    <Sidebar
      breakPoint='always'
      transitionDuration={300}
      backgroundColor="#BF2F38"
      rtl={false}
      style={
        { height: "100vh" }
      }> 
      <Menu

        menuItemStyles={{
          button: ({ level, active, disabled }) => {
            if (level === 0) {
              return {
                color: disabled ? "#eee" : "#FFFFFF",
                "&:hover": {
                  color: "#BF2F38 !important",
                },
              };
            }
            if (level === 1) {
              return {
                color: disabled ? "#eee" : "#FFFFFF",
                backgroundColor:'#c5434b ',
                "&:hover": {
                  backgroundColor:'transparent',
                  color: "#BF2F38 !important",
                },
              };
            }
          },
        }}
      >
        <Box mt={4}/>
        <MenuItem onClick={()=>{handlenavigate('/')}} icon={<DashboardIcon />}>Dashboard</MenuItem>
        <MenuItem onClick={()=>{handlenavigate('validations')}} icon={<CreditCardIcon />}>Validações</MenuItem>
        <MenuItem onClick={()=>{handlenavigate('schedules')}} icon={<CalendarTodayOutlinedIcon />}>Agendamentos</MenuItem>
        <SubMenu icon={<PeopleOutlinedIcon />} label="Acordo">
          <MenuItem onClick={()=>{handlenavigate('documents')}} >Documentos</MenuItem>
          <MenuItem onClick={()=>{handlenavigate('acts')}}>Actos Contratados</MenuItem>
        </SubMenu>
         <SubMenu icon={<ConfirmationNumberIcon/>} label="Esquebras">
          <MenuItem onClick={()=>{handlenavigate('esquebras')}} >Lista</MenuItem>
          <MenuItem onClick={()=>{handlenavigate('esquebras/usages')}} >Utilizações</MenuItem>
         </SubMenu>
        <MenuItem onClick={()=>{handlenavigate('current-account')}} icon={<AccountBalanceWalletIcon />}>Conta Corrente</MenuItem>
        <MenuItem onClick={()=>{logout()}} icon={<LogoutIcon />}>Sair</MenuItem>
      </Menu>
    </Sidebar>

  );
}

export default MySideBar;
